module.exports = __webpack_public_path__ + "fonts/Inter-ExtraLightItalic.84c2665.woff";